import { render, staticRenderFns } from "./TerritoryContactsListSub.vue?vue&type=template&id=16233ec2&scoped=true&"
import script from "./TerritoryContactsListSub.vue?vue&type=script&lang=js&"
export * from "./TerritoryContactsListSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16233ec2",
  null
  
)

export default component.exports